import React, { useState, useCallback, useEffect } from "react";
import Bubble from "./Bubble";
import LinePlot from "./LinePlot";
import Tabletop from "tabletop";
import * as d3 from "d3";
import clean_cum_ret_data from "./helpers/clean_cum_ret_data.js";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  NavLink
} from "react-router-dom";

// This site has 3 pages, all of which are rendered
// dynamically in the browser (not server rendered).
//
// Although the page does not ever refresh, notice how
// React Router keeps the URL up to date as you navigate
// through the site. This preserves the browser history,
// making sure things like the back button and bookmarks
// work properly.
export default function App() {
  const [mcScreenData, setmcScreenData] = useState({});
  const [cumRetData, setcumRetData] = useState({});
  // const [sector, setSector] = useState(2);
  // const [xAxisVariable, setxAxisVariable] = useState("PerFrom250DMA");
  // Array(12) [
  // 0: "Technology"
  // 1: "Consumer Cyclical"
  // 2: "Communication Services"
  // 3: "Financial Services"
  // 4: "Consumer Defensive"
  // 5: "Healthcare"
  // 6: "Energy"
  // 7: "Utilities"
  // 8: "Industrials"
  // 9: "Basic Materials"
  // 10: "Real Estate"

  // ]
  //OPERATOR
  const sector = 3;
  const showAll = 0;

  const fetchBusinesses3 = useCallback(async () => {
    const mc_screen_data = await d3.csv(
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vRI8Tm5tHY1Z_drVsGOIt26HWjmMCE9USRAJLRSgPT9nVKAk72UPJi1KM9CfdMBy03-fgPBmytkrbve/pub?gid=0&single=true&output=csv"
    );
    console.log("fetchBusinesses3");
    const cum_ret_data = await d3.csv(
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTiLPpbvCwW9yvEdQGybEILobE1i61hFHVFGMrAFwrvs5DlwFSmhOvp9FEc2H0E33VsVl83SSRZpsk5/pub?gid=205684055&single=true&output=csv"
    );
    console.log(cum_ret_data[0]);
  }, []);

  const fetchBusinesses = useCallback(() => {
    console.log("in fetch");
    Tabletop.init({
      key: "1XXG08DG-Yj4qTWsyyq1acLQZUksW_uFKN_bj51nHopU",
      // key: "1BdTU1_wzZe3t5WNHqW4EoHdltnKD9rUb2WMRM0S4Nac",
      simpleSheet: true
    }).then(function (data) {
      console.log("in set fetch");
      setmcScreenData(data);
    });
  }, []);

  const fetchBusinessesCumRet = useCallback(() => {
    //https://docs.google.com/spreadsheets/d/1UUwR9Y4ExPdAWuMFWouhwptRFrw-zjWbQZ_9mx0fh_4/edit?usp=sharing
    Tabletop.init({
      key: "1UUwR9Y4ExPdAWuMFWouhwptRFrw-zjWbQZ_9mx0fh_4",
      simpleSheet: true
    }).then(function (response) {
      console.log(
        "step1: Is data for cum ret coming in from spreadsheet in App.js. fetchBusinessesCumRet Callback"
      );
      const cleandata_nivo_line = clean_cum_ret_data(response);
      setcumRetData(cleandata_nivo_line);
    });
  }, []);

  useEffect(() => {
    // To fetch mc screen data.
    fetchBusinesses();
    // const interval = setInterval(() => {
    //   setSector(3);
    //   fetchBusinesses();
    // }, 5000);
    // return () => clearInterval(interval);
  }, [fetchBusinesses]);

  //------------------------------

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      fetchBusinessesCumRet();
    }

    return () => (mounted = false);
  }, [fetchBusinessesCumRet]);

  // useEffect(() => {
  //   fetchBusinesses3();
  // }, [fetchBusinesses3]);

  const newTo = {
    pathname: "/sheet/1UUwR9Y4ExPdAWuMFWouhwptRFrw-zjWbQZ_9mx0fh_4",
    param1: "sheetId1",
    search: "?workSheetId=4-cumulative",
    myKey: "newKey"
  };

  const newTo2 = {
    pathname: "/sheet/1jmEuROyUVDuGFu9NSfOzfdIClVsKHzA2_cVU1nvSdsk",
    param1: "sheetId1",
    search: "?workSheetId=4-cumulative",
    myKey: "newKey"
  };

  //1jmEuROyUVDuGFu9NSfOzfdIClVsKHzA2_cVU1nvSdsk

  const earnings_APR14 = {
    pathname: "/sheet/1jmEuROyUVDuGFu9NSfOzfdIClVsKHzA2_cVU1nvSdsk",
    param1: "sheetId1",
    search: "?workSheetId=4-cumulative",
    myKey: "newKey"
  };

  return (
    <>
      <Router>
        <div>
          {/* <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/bubble">Bubble</Link>
            </li>
            <li>
              <NavLink to={newTo}> SP 500 </NavLink>
            </li>

            <li>
              <NavLink to={newTo2}> Containers Ships </NavLink>
            </li>
          </ul> */}

          <Switch>
            <Route exact path="/">
              <LinePlot />
            </Route>
            <Route path="/about">
              <About />
            </Route>
            <Route path="/bubble">
              {mcScreenData && !!mcScreenData.length && (
                <Bubble
                  in_data={mcScreenData}
                  sector={sector}
                  showAll={showAll}
                  cumRetData={cumRetData}
                />
              )}
            </Route>

            <Route path="/sheet/:sheetId" component={LinePlot} />
          </Switch>
        </div>
      </Router>
    </>
  );
}

// You can think of these components as "pages"
// in your app.

function Home() {
  return (
    <div>
      <h2>Home</h2>
    </div>
  );
}

function About() {
  return (
    <div>
      <h2>About</h2>
    </div>
  );
}
